import axios from 'axios';

export const ParentOrganizationsApi = {
  loadTableData: filter =>
    axios.get(`/api/public/info/paging/service_provider?filter=${filter}`)
};
